<template>
  <v-footer
    class="footer d-flex justify-space-between align-end"
    :class="
      isLandscape
        ? `footer--landscape px-8 ${tenantName}`
        : `footer--portrait px-6 ${tenantName}`
    "
  >
    <v-col
      class="footer-logo pa-0 d-flex justify-start"
      :class="logoClass"
      cols="3"
    >
      <v-img
        :src="logoUrl"
        :max-height="logoHeight"
        :max-width="logoWidth"
        contain
      />
    </v-col>
    <v-spacer></v-spacer>
    <template v-if="isLandscape">
      <div class="d-flex justify-end align-end flex-column mb-2 qr-code">
        <v-img
          :src="qrCodeUrl"
          :max-height="QRHeight"
          :max-width="QRHeight"
          contain
        />
        <p class="text-center text-h6 mt-n2 w-100 text-footer">
          {{ $t("room.booking") }}
        </p>
      </div>
    </template>
    <template v-else>
      <v-col
        cols="4"
        class="footer__code d-flex justify-end align-end pa-0 mb-2"
      >
        <template v-if="isMeetingRoom">
          <v-col
            cols="9"
            class="pa-0 d-flex justify-center align-self-center pt-4"
          >
          </v-col>
          <v-col class="pa-0 align-end justify-end">
            <v-img
              class="align-self-center"
              :src="qrCodeUrl"
              :max-height="QRHeight"
              contain
            />
            <p class="text-center text-subtitle-1 text-md-body-1 text-lg-h6">
              {{ $t("room.booking") }}
            </p>
          </v-col>
        </template>
        <template v-else>
          <v-col cols="10" class="pa-0 mb-n1 pr-2">
            <p class="text-right">{{ $t("footer.link-to") }}</p>
            <p class="text-right">{{ $t("footer.booking") }}</p>
          </v-col>

          <v-img
            class="mb-n1"
            :src="qrCodeUrl"
            contain
            :height="QRHeight"
            :width="QRHeight"
            :max-height="QRHeight"
            :max-width="QRHeight"
          />
        </template>
      </v-col>
    </template>
  </v-footer>
</template>

<script lang="ts" setup>
import { Orientation, Page } from "~/types/enum";
const route = useRoute();
const props = defineProps({
  orientation: {
    type: String as PropType<Orientation>,
    required: true,
  },
});

const tenantName = computed(() => {
  return route.params.tenant ?? "";
});
const qrCodeUrl = computed(() =>
  tenantName.value ? `/${tenantName.value}/qr-code.png` : "/qr-code.png"
);
const logoUrl = computed(() =>
  tenantName.value ? `/${tenantName.value}/logo.png` : "/logo.png"
);
const logoClass = computed(() => {
  if (isLandscape.value || tenantName.value === "uko-tower") {
    return "align-self-center";
  }
  return "align-self-end mb-6";
});

const orientation = computed(() => props?.orientation);
const isLandscape = computed(() => orientation.value === Orientation.landscape);
const isMeetingRoom = computed(() => route.fullPath.includes(Page.MeetingRoom));
const logoHeight = computed(() => {
  if (tenantName.value === "uko-tower") {
    return isLandscape.value ? 130 : 200;
  }
  return 90;
});
const logoWidth = computed(() => {
  if (tenantName.value === "uko-tower") {
    return logoHeight.value;
  }
  return isLandscape.value ? 200 : 220;
});

const QRHeight = computed(() => {
  if (tenantName.value === "uko-tower") {
    return isLandscape.value ? 120 : 210;
  }
  return 90;
});
</script>

<style scoped lang="scss">
.footer {
  position: relative;

  &--portrait {
    height: $footer-height;

    &.uko-tower {
      background-color: white;

      .text-right {
        text-transform: uppercase;
        color: rgb(var(--v-theme-footer));
        line-height: 2rem;
        font-size: 1.8rem;
        margin-bottom: 15px;
      }
    }
  }
  &--landscape {
    border-top: 1px solid $lightgrey;

    &.uko-tower {
      border-color: transparent;
      margin: 0;
      padding-left: 0px;
      padding-right: 0px;
      background-color: white;

      .footer-logo {
        margin-left: -10px;
      }

      .qr-code {
        margin-top: 5px;
        margin-right: -10px;
      }

      .text-footer {
        font-weight: bold;
        text-transform: uppercase !important;
      }
    }
  }
}
</style>
